/**
 * Anonymous session id (PRD §5.F): a new session starts after 30 minutes of inactivity.
 * Kept in localStorage (not sessionStorage) so returning from WhatsApp continues the session.
 */
import { safeStorage } from '@/lib/storage'
import { uuid } from '@/lib/uuid'

const KEY = 'angadi.session'
export const SESSION_IDLE_MS = 30 * 60 * 1000

interface Stored {
  id: string
  last: number
}

/** Returns the current session id and whether it was just started (→ log `app_open`). */
export function touchSession(now = Date.now()): { id: string; isNew: boolean } {
  let stored: Stored | null = null
  try {
    stored = JSON.parse(safeStorage.get(KEY) ?? 'null') as Stored | null
  } catch {
    stored = null
  }
  const isNew = !stored || now - stored.last > SESSION_IDLE_MS
  const id = isNew ? uuid() : stored!.id
  safeStorage.set(KEY, JSON.stringify({ id, last: now }))
  return { id, isNew }
}
